import React, { useState, useEffect } from "react";
// 👇 SEMUA IMPORT SUDAH DIUBAH KE .WEBP 👇
import bgDesktop from "../../Img/adaddesktop.webp";
import bgMobile from "../../Img/adatmobile.webp";
import hiasanLogo from "../../Img/hiasan-3.webp";
import pengantinImg from "../../Img/pengantin.webp";

// Import Asset Bunga
import bungaKananImg from "../../Img/bungakanan.webp";
import bungaKiriImg from "../../Img/bungakiri.webp";
import bungaGoyangKananImg from "../../Img/bungagoyangkanan.webp";
import bungaGoyangKiriImg from "../../Img/bungagoyangkiri.webp";

// Import Asset Pohon
import pohonKananImg from "../../Img/pohonkanan.webp";
import pohonKiriImg from "../../Img/pohonkiri.webp";

// Import Asset Alas
import bmImg from "../../Img/bm.webp";

export default function Home({ fadeIn }) {
  // 👇 PERBAIKAN 1: isMobile dibuat dinamis mendengarkan ukuran layar 👇
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const styles = {
    // 1. Container Utama
    container: {
      position: "relative",
      // 👇 PERBAIKAN 2: Menggunakan svh agar tidak terpotong URL Bar di HP 👇
      height: "100svh",
      width: "100%",
      backgroundImage: `url(${isMobile ? bgMobile : bgDesktop})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      overflow: "hidden",
    },

    // --- BAGIAN ALAS TENGAH ---
    alasWrapper: {
      position: "absolute",
      bottom: "0vh",
      left: "50%",
      transform: "translateX(-50%)",
      width: "clamp(300px, 100vw, 1200px)",
      zIndex: 1,
      pointerEvents: "none",
    },
    alasImg: {
      width: "100%",
      height: "auto",
      display: "block",
      opacity: 0,
      animation: "alas-muncul 3s ease-out 0.2s forwards",
    },

    // --- BAGIAN BUNGA KIRI ---
    bungaKiriWrapper: {
      position: "absolute",
      bottom: "0vh",
      left: "0vw",
      width: "clamp(200px, 40vw, 270px)", // Sedikit diperkecil batas bawahnya agar tidak memakan ruang di HP kecil
      zIndex: 1,
      opacity: 0,
      animation: "bunga-muncul-kiri 4s ease-out 0.5s forwards",
      pointerEvents: "none",
    },

    // --- BAGIAN BUNGA KANAN ---
    bungaKananWrapper: {
      position: "absolute",
      bottom: "0vh",
      right: "-5vw",
      width: "clamp(200px, 40vw, 270px)",
      zIndex: 1,
      opacity: 0,
      animation: "bunga-muncul-kanan 4s ease-out 0.5s forwards",
      pointerEvents: "none",
    },

    bungaStatis: {
      width: "100%",
      height: "auto",
      display: "block",
      willChange: "transform", // Optimasi animasi GPU
    },

    bungaGoyangKiri: {
      position: "absolute",
      bottom: "90%",
      left: "-30%",
      width: "80%",
      height: "auto",
      transformOrigin: "bottom left",
      animation: "bunga-goyang 5s ease-in-out infinite alternate",
      zIndex: 2,
      willChange: "transform",
    },
    bungaGoyangKanan: {
      position: "absolute",
      bottom: "90%",
      right: "-30%",
      width: "80%",
      height: "auto",
      transformOrigin: "bottom right",
      animation: "bunga-goyang 5s ease-in-out infinite alternate",
      zIndex: 2,
      willChange: "transform",
    },

    // --- BAGIAN POHON ---
    pohonKiriWrapper: {
      position: "absolute",
      bottom: "70%",
      left: "-5vw",
      width: "clamp(150px, 25vw, 300px)",
      zIndex: 2,
      opacity: 0,
      animation: "bunga-muncul-kiri 4s ease-out 0.8s forwards",
      pointerEvents: "none",
    },
    pohonKananWrapper: {
      position: "absolute",
      bottom: "70%",
      right: "-5vw",
      width: "clamp(150px, 25vw, 300px)",
      zIndex: 2,
      opacity: 0,
      animation: "bunga-muncul-kanan 4s ease-out 0.8s forwards",
      pointerEvents: "none",
    },
    pohonImg: {
      width: "100%",
      height: "auto",
      display: "block",
    },

    // 2. Shape Latar Belakang
    shapeBackground: {
      position: "absolute",
      top: "16px",
      bottom: "16px",
      left: "16px",
      right: "16px",
      backgroundColor: "rgba(225, 221, 210, 0.85)",
      borderRadius: "clamp(20px, 4vw, 40px)",
      border: "2px solid #ffffff",
      zIndex: 3,
    },

    // 3. Pembungkus Konten
    contentWrapper: {
      position: "relative",
      height: "100%",
      width: "100%",
      zIndex: 4,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      pointerEvents: "none",
    },

    topContent: {
      width: "100%",
      maxWidth: "550px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      paddingTop: "15svh", // Diperkecil sedikit agar ada ruang untuk gambar pengantin
      paddingLeft: "5%",
      paddingRight: "5%",
      pointerEvents: "auto",
    },
    headerText: {
      fontSize: "clamp(12px, 3vw, 14.4px)",
      letterSpacing: "0.2em",
      color: "#49312b",
      marginBottom: "2vh",
      fontWeight: "600",
      textTransform: "uppercase",
    },
    logoWrapper: {
      position: "relative",
      width: "clamp(60px, 10vh, 100px)",
      height: "clamp(60px, 10vh, 100px)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: "2vh",
    },
    logoImg: {
      width: "100%",
      height: "100%",
      objectFit: "contain",
    },
    initials: {
      position: "absolute",
      fontFamily: "Salsa, cursive",
      fontSize: "clamp(20px, 3.5vh, 28px)",
      color: "#78350f",
      marginTop: "5px",
    },
    coupleRow: {
      display: "flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
    },

    sideNameLeft: {
      width: "42%",
      textAlign: "right",
      display: "flex",
      flexDirection: "column",
      opacity: 0,
      animation: "nama-slide-kiri 1.5s ease-out 1s forwards",
    },
    sideNameRight: {
      width: "42%",
      textAlign: "left",
      display: "flex",
      flexDirection: "column",
      opacity: 0,
      animation: "nama-slide-kanan 1.5s ease-out 1s forwards",
    },
    ampersandWrapper: {
      width: "16%",
      display: "flex",
      justifyContent: "center",
      fontFamily: "serif",
      fontSize: "clamp(30px, 5vw, 50px)",
      color: "#49312b",
      opacity: 0,
      animation: "ampersand-muncul 1.5s ease-out 1s forwards",
    },

    nameText: {
      fontFamily: "'Great Vibes', cursive",
      // 👇 PERBAIKAN 3: Ukuran font diperkecil sedikit agar muat untuk nama "Alfin" 👇
      fontSize: "clamp(35px, 6vw, 65px)",
      fontWeight: "bold",
      color: "#78350f",
      lineHeight: "0.8",
    },
    subLocation: {
      fontSize: "clamp(13px, 2vw, 20px)",
      color: "#49312b",
      marginTop: "5px",
    },

    imagePengantinWrapper: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      marginTop: "auto",
      pointerEvents: "auto",
      zIndex: 5,
    },
    imagePengantin: {
      width: "clamp(280px, 85vw, 450px)",
      height: "auto",
      maxHeight: "45svh", // Memastikan gambar pengantin tidak menabrak teks di HP
      objectFit: "contain",
      objectPosition: "bottom",
    },
  };

  return (
    <div id="home" style={styles.container}>
      <style>
        {`
          @keyframes bunga-muncul-kiri {
            0% { opacity: 0; transform: translate(-60px, 60px) scale(0.8); }
            100% { opacity: 1; transform: translate(0, 0) scale(1); }
          }

          @keyframes bunga-muncul-kanan {
            0% { opacity: 0; transform: translate(60px, 60px) scale(0.8); }
            100% { opacity: 1; transform: translate(0, 0) scale(1); }
          }

          @keyframes bunga-goyang {
            0%, 100% { transform: rotate(-3deg); }
            50% { transform: rotate(3deg); }
          }

          @keyframes alas-muncul {
            0% { opacity: 0; transform: translateY(60px) scale(0.8); }
            100% { opacity: 1; transform: translateY(0) scale(1); }
          }

          @keyframes nama-slide-kiri {
            0% { opacity: 0; transform: translateX(-40px); }
            100% { opacity: 1; transform: translateX(0); }
          }

          @keyframes nama-slide-kanan {
            0% { opacity: 0; transform: translateX(40px); }
            100% { opacity: 1; transform: translateX(0); }
          }

          @keyframes ampersand-muncul {
            0% { opacity: 0; transform: scale(0.5); }
            100% { opacity: 1; transform: scale(1); }
          }
        `}
      </style>

      {/* --- ALAS TENGAH BAWAH (Hanya muncul jika di HP) --- */}
      {isMobile && (
        <div style={styles.alasWrapper}>
          <img src={bmImg} alt="Alas Tengah" style={styles.alasImg} />
        </div>
      )}

      {/* --- HIASAN BUNGA KIRI --- */}
      <div style={styles.bungaKiriWrapper}>
        <img src={bungaKiriImg} alt="Bunga Kiri" style={styles.bungaStatis} />
        <img
          src={bungaGoyangKiriImg}
          alt="Bunga Kiri Goyang"
          style={styles.bungaGoyangKiri}
        />
      </div>

      {/* --- HIASAN BUNGA KANAN --- */}
      <div style={styles.bungaKananWrapper}>
        <img src={bungaKananImg} alt="Bunga Kanan" style={styles.bungaStatis} />
        <img
          src={bungaGoyangKananImg}
          alt="Bunga Kanan Goyang"
          style={styles.bungaGoyangKanan}
        />
      </div>

      {/* --- HIASAN POHON KIRI --- */}
      <div style={styles.pohonKiriWrapper}>
        <img src={pohonKiriImg} alt="Pohon Kiri" style={styles.pohonImg} />
      </div>

      {/* --- HIASAN POHON KANAN --- */}
      <div style={styles.pohonKananWrapper}>
        <img src={pohonKananImg} alt="Pohon Kanan" style={styles.pohonImg} />
      </div>

      {/* SHAPE BACKGROUND LAYER */}
      <div style={styles.shapeBackground}></div>

      {/* CONTENT LAYER */}
      <div style={styles.contentWrapper}>
        <div style={styles.topContent}>
          {/* 👇 PERBAIKAN TEKS: Sesuai Tema Kristen 👇 */}
          <div style={styles.headerText}>✤ The Wedding Of ✤</div>

          <div style={styles.logoWrapper}>
            <img src={hiasanLogo} alt="Hiasan" style={styles.logoImg} />
            <span style={styles.initials}>AR</span>
          </div>

          <div style={styles.coupleRow}>
            <div style={styles.sideNameLeft}>
              {/* 👇 PERBAIKAN NAMA: Alfin 👇 */}
              <span style={styles.nameText}>Alfin</span>
              <span style={styles.subLocation}>Nias</span>
            </div>
            <div style={styles.ampersandWrapper}>&</div>
            <div style={styles.sideNameRight}>
              <span style={styles.nameText}>Ruri</span>
              <span style={styles.subLocation}>Malang</span>
            </div>
          </div>
        </div>

        <div style={styles.imagePengantinWrapper}>
          <img
            src={pengantinImg}
            alt="Pengantin"
            style={styles.imagePengantin}
          />
        </div>
      </div>
    </div>
  );
}
